exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".New-form {\n    background-color: #6c7ae0 !important;\n    color:rgb(250, 244, 244);;\n    border-radius:5px;\n}\n.form-stat {\n    display: flex;\n    justify-content: space-around;\n}\n.bg-l:hover {\n    background-color: blue !important;\n}\nimg.g-icon-alinment {\n    width: 18px;\n    top: 28%;\n}\n\n", ""]);

